export enum ScheduledOperationStatusColorEnum {
    Unknown = "",
    Created = "pistachio",
    Requested = "maizecrayola",
    Approved = "success",
    Modified = "yelloworange",
    Removed = "orangered",
    Activated = "secondary",
    Terminated = "medium",
    Cancelled = "redsalsa",
    PendingAuth = "maizecrayola",
    Revoked = "redsalsa"
}